import React, { useState, useEffect } from 'react';
import { EVENTS } from '../utilities/CONSTANTS';

const useUserTodoCount = () => {
    const [todoCounts, setTodoCounts] = useState({ todoCount: 0, questionCount: 0 });

    useEffect(() => {
        const handleTodoChange = () => {
            setTodoCounts(window._todoCounts);
        };
        window.addEventListener(EVENTS.USER_TODO_COUNT, handleTodoChange);
        return () => window.removeEventListener(EVENTS.USER_TODO_COUNT, handleTodoChange);
    }, []);

    return todoCounts;
};

export default useUserTodoCount;
